import React, { useContext, useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import './Resource.css';

import api from '../../Utils/Api';
import { CurrentUserContext } from '../../Contexts/CurrentUserContext';
import { JourneyContext } from '../../Contexts/JourneyContext';

import ResourceTestBeginning from './ResourceTest/ResourceTestBeginning';
import ResourceTestEnding from './ResourceTest/ResourceTestEnding';
import ResourceHtml from './ResourceHtml/ResourceHtml';
import ResourceVideoConf from './ResourceVideoConf/ResourceVideoConf';
import ResourceExerciseBeginning from './ResourceExercise/ResourceExerciseBeginning';
import ResourceExerciseEnding from './ResourceExercise/ResourceExerciseEnding';
import HorizontalTree from '../App/Common/HorizontalTree/HorizontalTree';
import Calendar from '../Calendar/Calendar';

const Resource = ({ data }) => {
    const { token } = useContext(CurrentUserContext);
    const { currentPlace, breadCrumbs, setBreadCrumbs, setCurrentPlace } =
        useContext(JourneyContext);

    const [currentStep, setCurrentStep] = useState(undefined);
    const { id: selectedStepId } = useParams();

    useEffect(() => {
        return () => {
            setBreadCrumbs([]);
        };
    }, []);

    useEffect(() => {
        api.getStep(token, parseInt(selectedStepId))
            .then((res) => {
                //    console.log(res)
                if (res.type !== 'videofile') {
                    setCurrentStep(res);
                    setBreadCrumbs(res.parents);
                    setCurrentPlace(res.parents.slice(-1)[0]);
                } else {
                    api.getStep(token, res.previous_step_id).then((r) => {
                        setCurrentStep(r);
                        setBreadCrumbs(r.parents);
                        setCurrentPlace(r.parents.slice(-1)[0]);
                    });
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, [selectedStepId, token, setBreadCrumbs, setCurrentPlace]);

    // console.log(currentStep)

    const containerStyle =
        currentStep?.html !== null
            ? { justifyContent: 'flex-start' }
            : { justifyContent: 'center' };

    const renderResourceContent = () => {
        if (currentStep.html) {
            return <ResourceHtml data={currentStep.html} />;
        }
        if (currentStep.test) {
            return currentStep.test.attempts_used > 0 ? (
                <ResourceTestEnding data={currentStep.test} />
            ) : (
                <ResourceTestBeginning data={currentStep.test} />
            );
        }
        if (currentStep.exercise) {
            return currentStep.exercise.attempts_used > 0 ? (
                <ResourceExerciseEnding data={currentStep.exercise} />
            ) : (
                <ResourceExerciseBeginning data={currentStep.exercise} />
            );
        }
        if (currentStep.conference) {
            return <ResourceVideoConf data={currentStep.conference} />;
        }
        return null;
    };

    const [tab, setTab] = useState(false);
    const [titleTag, setTitle] = useState('');

    const handleOpenTab = (title) => {
        if (title === 'Все курсы') {
            setTab(false);
            setTitle('_courses');
        } else if (title === 'Календарь') {
            setTab(true);
            setTitle('_calendar');
        }
    };

    const handleTitle = (type) => {
        if (type === 'test') {
            return 'Тест';
        } else if (type === 'exercise') {
            return 'Упражнение';
        } else if (type === 'html') {
            return 'Материал';
        }
    };
    return (
        currentStep && (
            <div className='resource__container'>
                <div className='resource__body'>
                    <div className='tab__wrap'>
                        <div
                            className={'tab__btn' + (titleTag ? titleTag === '_courses' : 'true')}
                            onClick={() => handleOpenTab('Все курсы')}
                        >
                            {handleTitle(currentStep.type)}
                        </div>
                        {/* <div className={'tab__btn' + (titleTag ? titleTag === '_calendar' : 'false')} onClick={() => handleOpenTab('Календарь')}>Календарь</div> */}
                        {/* <div className={'tab__btn' + (titleTag ? titleTag === '_archive' : 'false')} onClick={() => handleOpenTab('Архив')}>Архив</div> */}
                    </div>
                    <div className='resource__top'>
                        {/* <HorizontalTree type='resource' id={parseInt(selectedStepId)} /> */}
                        {currentStep.type !== 'test' && currentStep.type !== 'exercise' && (
                            <div className='resource__buttons'>
                                {currentStep.previous_step_id ? (
                                    <Link to={`/resource/${currentStep.previous_step_id}`}>
                                        <div className='resource__button backward'>
                                            {'Предыдущий материал'}
                                        </div>
                                    </Link>
                                ) : (
                                    <div className='resource__button backward disabled'>
                                        Предыдущий урок
                                    </div>
                                )}
                                {currentStep.next_step_id ? (
                                    <Link to={`/resource/${currentStep.next_step_id}`}>
                                        <div className='resource__button forward'>
                                            {'Следующий материал'}
                                        </div>
                                    </Link>
                                ) : (
                                    <div className='resource__button forward disabled'>
                                        Следующий урок
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    {tab && titleTag === '_calendar' && (
                        <div className='courses__calendar'>
                            <Calendar></Calendar>
                        </div>
                    )}
                    {!tab && (
                        <div className='courses__calendar'>
                            {/* <div className='resource__title'>{currentStep.title}</div> */}
                            <div className='resource__main' style={{ ...containerStyle }}>
                                {renderResourceContent()}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    );
};

export default Resource;
